import workspaceQuery from 'graphql/queries/supplier/SupplierAttributeConfigWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/supplier/SupplierAttributeConfigListQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/SupplierAttributeConfigQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/SupplierAttributeConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/SupplierAttributeConfigMutation.graphql';
import fragment from 'graphql/fragments/supplier/SupplierAttributeConfigFragment.graphql';

const SupplierAttributeConfig = {
  type: 'SupplierAttributeConfig',
  title: 'Supplier Attributes',
  formTitle: 'Supplier Attribute',
  formUrl: '/Suppliers/AttributeConfig/Details/',
  workspaceUrl: '/Suppliers/AttributeConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'SUPPLIERS_ATTRIBUTES',
};

export default SupplierAttributeConfig;
